import { deleteAssessmentMutation } from 'legacy/src/queries';

const deleteAssessment = async (
  apolloClient = {},
  itemId,
  shouldConfirmDelete = false,
) => {
  const response = await apolloClient.mutate({
    mutation: deleteAssessmentMutation,
    fetchPolicy: 'network-only',
    variables: { itemId, shouldConfirmDelete },
  });

  const {
    data: {
      deleteAssessment: { deleted, message, canBeDeleted },
    },
  } = response;
  return { deleted, message, canBeDeleted };
};

export default deleteAssessment;
